import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const AppSearch = ({ value, onChange, placeholder }) => {
  return (
    <TextField
      fullWidth
      variant="outlined"
      size="small"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder || "Rechercher..."}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: 'var(--text-muted)' }} />
          </InputAdornment>
        ),
      }}
      sx={{
        marginBottom: '20px',
        '& .MuiOutlinedInput-root': {
          backgroundColor: '#ffffff',
          borderRadius: '10px', // Cohérent avec tes cartes
          '& fieldset': {
            borderColor: '#d8dbe0',
          },
          '&:hover fieldset': {
            borderColor: 'var(--primary)',
          },
          '&.Mui-focused fieldset': {
            borderColor: 'var(--primary)',
            borderWidth: '2px',
          },
        },
        '& .MuiInputBase-input': {
          fontSize: '0.9rem',
          padding: '10px 12px',
        }
      }}
    />
  );
};

export default AppSearch;